var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "History Track",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1100px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', [_c('el-form', {
    staticClass: "el-form-filter",
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.getDataList(1);
      }
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "value-format": "timestamp",
      "type": "daterange",
      "range-separator": "~",
      "start-placeholder": "Start Date",
      "end-placeholder": "Ending Date"
    },
    on: {
      "change": function change($event) {
        return _vm.getDataList(1);
      }
    },
    model: {
      value: _vm.watchStartToEndSecondTimeRange,
      callback: function callback($$v) {
        _vm.watchStartToEndSecondTimeRange = $$v;
      },
      expression: "watchStartToEndSecondTimeRange"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mt20 pb20"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.engagementStatusFormat(scope.row.status)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Handling Time",
      "width": "164px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("parseTimeSecond")(scope.row.createAt)) + " ")];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "userInfo",
      "align": "center",
      "label": "Handler"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.userInfo.nickname))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "label": "Reopen Reason / Remark"
    }
  })], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }